import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { easings } from '../../styles/vars/easings.style'
import { font } from '../../styles/vars/font.style'
import { mq } from '../../styles/vars/media-queries.style'
import { getStyles, textStylesConfig } from '../../styles/vars/textStyles.style'

export const ExpeditionHeroMain = styled.div`
  background-color: ${props => props.bgColor};
  position: relative;
`

export const ExpeditionHeroIntro = styled.div`
  h1 {
    word-wrap: break-word;
    hyphens: manual;
  }
`

export const ExpeditionHeroTitle = styled.div`
  br {
    display: none;
  }
`

export const ExpeditionHeroVimeo = styled.div`
  border-radius: 0.6rem;
  opacity: ${props => (props.visible ? 1 : 0)};
  overflow: hidden;
  position: relative;
  aspect-ratio: 1892/1064;

  ${props =>
    props.visible &&
    `
    transition: opacity 1s ${easings.inOut.quart};
    transition-delay: ${props.delay}s;
  `}
`

export const ExpeditionHeroIntroText = styled.p`
  padding-top: 5rem;

  ${mq.desk} {
    columns: 2;
  }

  :first-letter {
    ${getStyles(textStylesConfig.heading3)}
    font-family: ${font.headingAlt.family};
    float: left;
    line-height: 1;
    margin-bottom: -1rem;
    ${clamp('font-size', 58, 58)}
    ${clamp('padding-right', 10, 12)};
  }
`
